import React from 'react';
import PropTypes from 'prop-types';
import MuiSnackbar from '@mui/material/Snackbar';

const originToAnchorOriginMap = {
  topLeft: { vertical: 'top', horizontal: 'left' },
  topCenter: { vertical: 'top', horizontal: 'center' },
  topRight: { vertical: 'top', horizontal: 'right' },
  bottomLeft: { vertical: 'bottom', horizontal: 'left' },
  bottomCenter: { vertical: 'bottom', horizontal: 'center' },
  bottomRight: { vertical: 'bottom', horizontal: 'right' },
};

const Snackbar = ({ origin = 'topCenter', children, ...other }) => {
  const anchorOrigin = originToAnchorOriginMap[origin];
  return (
    <MuiSnackbar anchorOrigin={anchorOrigin} {...other}>
      {children}
    </MuiSnackbar>
  );
};

Snackbar.propTypes = {
  children: PropTypes.node.isRequired,
  origin: PropTypes.oneOf(Object.keys(originToAnchorOriginMap)),
};

export default Snackbar;
